import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute } from '@tanstack/react-router'

import { PageCard, PageLayout } from '@/components/ui/page'

import { itemMasterDetail } from '@/features/item/api'
import { ItemMasterUpdateForm } from '@/features/item/components/item-master-form'

export const Route = createFileRoute('/_app/inventory/master/$id/edit')({
	loader: async ({ context: { qc }, params: { id } }) => {
		await qc.ensureQueryData(itemMasterDetail.qry({ id }))
	},
	component: Component,
})

function Component() {
	const { id } = Route.useParams()
	const { item } = useSuspenseQuery(itemMasterDetail.qry({ id })).data

	return (
		<PageLayout.Root>
			<PageLayout.Header
				breadcrumbs={[
					['/inventory', 'Inventory'],
					['/inventory/master', 'Master Bahan'],
					['/inventory/master/$id', item.name],
					[Route.fullPath, 'Edit Bahan'],
				]}
			/>
			<PageCard.Root>
				<PageCard.Header title="Update data master" />
				<ItemMasterUpdateForm />
			</PageCard.Root>
		</PageLayout.Root>
	)
}
